import { render } from "./PendingUsers.vue?vue&type=template&id=48186162"
import script from "./PendingUsers.vue?vue&type=script&lang=js"
export * from "./PendingUsers.vue?vue&type=script&lang=js"

import "./PendingUsers.vue?vue&type=style&index=0&id=48186162&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__